import request from '@/utils/httpRequest'

export default class DailyLogService {
  list(params) {
    return request({
      url: '/erp/cms/app/work/cmsWorkDaily/list',
      method: 'get',
      params: params
    })
  }

  view(id) {
    return request({
      url: '/erp/cms/app/work/cmsWorkDaily/queryById',
      method: 'get',
      params: { id }
    })
  }

  save(data) {
    return request({
      url: '/erp/cms/app/work/cmsWorkDaily/save',
      method: 'post',
      data: data
    })
  }

  delete(ids) {
    return request({
      url: '/erp/cms/app/work/cmsWorkDaily/delete',
      method: 'delete',
      params: { ids }
    })
  }

  /**
   * 获取已登记日期列表
   * @param {String} userId 用户ID
   * @param {String} erpMonth 年-月，格式：YYYY-MM
   * @param {String} dailyType 日志类型：1-工作日记，2-工程日志
   */
  getLogDates(userId, erpMonth, dailyType) {
    return request({
      url: '/erp/cms/app/work/cmsWorkDaily/list/month',
      method: 'get',
      params: {
        userId,
        erpMonth,
        dailyType
      }
    })
  }

  queryByProjectAndPermission (projectId, permission) {
    return request({
      url: `/extension/actCategory/queryByProjectAndPermission`,
      method: 'get',
      params: {projectId:projectId, permission:permission}
    })
  }

  getTaskDef (params) {
    return request({
      url: '/flowable/task/getTaskDef',
      method: 'get',
      params: params
    })
  }

    /**
   * 启动流程
   * @param {Object} params
   */
  startFlow (params) {
    return request({
      url: '/cms/flow/startFlow',
      method: 'post',
      data: params
    })
  }

  start (data) {
    return request({
      url: '/flowable/task/start',
      method: 'post',
      data: data
    })
  }

  /**
   * 查询当前用户是否存在钉钉账号
   */
  hasDingAccount () {
    return request({
      url: '/flowable/task/hasDingAccount',
      method: 'get'
    })
  }

  /**
   * 上传附件
   * @param {FormData} formData 文件数据
   */
  upload(formData) {
    return request({
      url: '/common/upload',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
